import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
const leftItems = ['Quer começar um negócio lucrativo trabalhando de casa', 'Busca uma renda extra com baixo investimento inicial', 'Ama velas, aromas e o universo do bem-estar', 'Quer conquistar sua independência financeira'];
const rightItems = ['Não tem experiência prévia mas tem vontade de aprender', 'Quer um passo a passo completo, sem enrolação', 'Busca um negócio criativo, terapêutico e prazeroso', 'Quer transformar um hobby em uma profissão rentável'];
export function TargetAudience() {
  return <section className="py-24 bg-white" data-id="element-209">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
        <FadeIn className="text-center mb-16" data-id="element-211">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-brand-brown" data-id="element-212">
            Este ebook é para você que...
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto mt-6 rounded-full opacity-50" data-id="element-213"></div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 mb-16" data-id="element-214">
          <div className="space-y-6" data-id="element-215">
            {leftItems.map((item, index) => <FadeIn key={index} delay={index * 0.1} direction="right" data-id="element-216">
                <div className="flex items-start gap-4 bg-brand-cream/50 p-4 rounded-xl border border-brand-blush/50" data-id="element-217">
                  <CheckCircleIcon className="w-6 h-6 text-brand-rose shrink-0 mt-0.5" data-id="element-218" />
                  <span className="text-brand-brown font-medium text-lg" data-id="element-219">
                    {item}
                  </span>
                </div>
              </FadeIn>)}
          </div>
          <div className="space-y-6" data-id="element-220">
            {rightItems.map((item, index) => <FadeIn key={index} delay={index * 0.1 + 0.2} direction="left" data-id="element-221">
                <div className="flex items-start gap-4 bg-brand-cream/50 p-4 rounded-xl border border-brand-blush/50" data-id="element-222">
                  <CheckCircleIcon className="w-6 h-6 text-brand-rose shrink-0 mt-0.5" data-id="element-223" />
                  <span className="text-brand-brown font-medium text-lg" data-id="element-224">
                    {item}
                  </span>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={0.6} className="text-center" data-id="element-225">
          <motion.a href="#oferta" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-brand-rose text-white px-10 py-4 rounded-full font-bold text-xl shadow-lg shadow-brand-rose/20 hover:bg-brand-rose/90 transition-colors" data-id="element-226">
            Sim, quero começar!
          </motion.a>
        </FadeIn>
      </div>
    </section>;
}